import { Component } from '@angular/core';
import { AdminService } from '../../../admin.service';
import { SnackService } from '@shared/services/snack.service';
import { ResponsibleService } from '@shared/services/responsible.service';
import { AdminActionsDirective } from '@app/main/admin/directives/admin-actions.directive';
import { responsibleFilters } from '@app/main/admin/components/admin-toolbar/admin-toolbar-filters';
import { IResponsible, ResponsibleType } from '@shared/interfaces';
import { DialogService, ExportService } from '@shared/services';
import { ModuleService } from '@shared/services/module.service';

@Component({
    selector: 'app-admin-toolbar-responsible',
    templateUrl: './admin-toolbar-responsible.component.html',
    styleUrls: ['./admin-toolbar-responsible.component.scss'],
    standalone: false
})
export class AdminToolbarResponsibleComponent extends AdminActionsDirective {
    filters = responsibleFilters;
    searchValue: string;

    constructor(
        private snack: SnackService,
        private responsibleService: ResponsibleService,
        private exportService: ExportService,
        adminService: AdminService,
        dialogService: DialogService,
        moduleService: ModuleService
    ) {
        super(adminService, dialogService, moduleService);
    }

    get item(): IResponsible {
        return this.selectedItem;
    }

    async exportItems(): Promise<void> {
        const data = await this.responsibleService.getAll({ type: ResponsibleType.all });
        return this.exportService.generateExcelForRS(data.items);
    }
}
